"use client";

import React from "react";
import {
    FaShieldAlt,
} from "react-icons/fa";

export default function TermConditon() {
    return (
        <main className="min-h-screen bg-white py-12 px-6">
            <div className="max-w-6xl mx-auto  rounded-2xl  p-10">
                {/* Header Section */}
                <div className="text-center mb-10">
                    <FaShieldAlt className="text-blue-600 text-6xl mx-auto mb-4" />
                    <h1 className="text-4xl font-bold text-gray-900">
                        Sureship – Terms & Conditions Policy
                    </h1>
                    <p className="text-gray-500 mt-2">
                        Last Updated: October 2025 | Please read carefully before use.
                    </p>
                </div>

                {/* Intro Section */}
                <section className="space-y-4 text-gray-700 leading-relaxed mb-10">
                    <p>
                        By accessing or using the Website or by using the Service on the
                        Website you agree to be bound by the Terms and Conditions set forth
                        below including any additional guidelines and future modifications.
                        Sureship may add to, change or remove any part of these Terms and
                        Conditions of Use at any time, without notice. Any changes to these
                        Terms and Conditions of Use or any terms published on this Website
                        apply as soon as they are released.
                    </p>
                    <p>
                        As a condition of your use of this Website, you agree that, You will
                        provide your proper and accurate Name as per Passport / Adhaar or
                        any other official ID issued by statutory body, Address, Email ID,
                        Contact Number, mobile, direct landline, and will be solely
                        responsible for the Information provided and in case of any error or
                        mistake in provision of information, Sureship will not be liable for
                        the same.
                    </p>
                    <p>
                        You will use this Website to make only appropriate transactions for
                        you or for another person for whom you are authorized to act, and
                        will inform such other persons about the Terms of Use that apply to
                        the transaction you have made on their behalf, including all rules
                        and restrictions applicable. You indemnify Sureship against any
                        illegal purchases made by you or any other person either legally
                        authorized or on account of your negligence.
                    </p>
                    <p>
                        Make sure that all information supplied by you on this Website is
                        correct, accurate, current and complete.
                    </p>
                    <p>
                        If you have an online User Account with this Website, you will
                        safeguard your login details such as login ID and password and will
                        supervise the same. You will be entirely responsible for any use or
                        misuse of your User Account by you and any other person.
                    </p>
                    <p>
                        Sureship have the right in its sole discretion to deny access to
                        anyone to this Website and the services we offer, at any time
                        without notice and for any reason, including, but not limited to,
                        for violation of these Terms of Use.
                    </p>
                    <p>
                        This Website and some other Website relating to Sureship, its
                        partners, subsidiaries, Service Providers, and so on are just for
                        your own and non – business utilizes. It is entirely denied to You
                        and of your partners and off shoots straight forwardly or by
                        implication connected to You, to outline, scrap, hack, information
                        mine, remove, gather, duplicate, disperse, trade, alter, offer or
                        transmit any substance or material from this Site, including however
                        not restricted to any information, indexed lists, content, pictures,
                        sound, video or connections for any business, business or open
                        reason.
                    </p>
                    <p>
                        The information and content provided on this Website including, the
                        availability of logistics services, as well as the infrastructure
                        used to provide such content and information, is proprietary to our
                        Service Providers or us.
                    </p>
                    <p>
                        The Customer must have the learning of all laws not restricted to
                        the reasonability of items being dispatched, bundling prerequisite,
                        required documentation for Shipments, non-deserting, and so forth
                        for the source and delivery destination. The Customer recognizes
                        that the Service Provider and Sureship
                    </p>
                    <p>
                        acknowledge the Shipment on said to contain premise and just on the
                        depiction given by the Customer on the waybill and other applicable
                        Shipping Documents. The substance of the Shipment must be
                        demonstrated by accurate portrayal in transit charge and other
                        transportation archives on which the Shipment has been offered.
                        Sureship and the Service Provider accept no obligation to any
                        individual for any misfortune or cost because of the Customer's
                        inability to agree to this arrangement. The Customer additionally
                        consents to hold Sureship and the Service Provider safe from and
                        against all cases, harms, liabilities, activities, misfortunes,
                        expenses, and costs of any nature at all, emerging out of Customer's
                        giving to Sureship or Service Provider inadequate, off base or false
                        documentation or inability to provide the required data. By no means
                        should Sureship or the Service Provider be considered in charge of
                        any risk emerging out of the products contained in the Customer's
                        Shipment.
                    </p>
                    <p>
                        <span className="font-bold text-blue-600">Assessment:</span>{" "}
                        Sureship or the Service Provider or the Shipping Company or any
                        administrative expert including traditions and security may open and
                        examine your shipment whenever.
                    </p>
                    <p>
                        <span className="font-bold text-blue-600">Protection:</span> To
                        obtain and keep up a protection to secure the Shipments amid the
                        execution of the Services. The Customer's protection might have all
                        hazard scope security against all dangers at each minute amid the
                        travel and capacity of the Shipments. Client in this demonstration
                        liberates Sureship or the Service Provider or the Shipping Company
                        from any and all duty regarding any occurrence or incident happened
                        amid the conveyance of the Shipment from its cause point to its last
                        goal.
                    </p>
                    <p>
                        <span className="font-bold text-blue-600">Documentation:</span> To
                        provide Sureship and the Service Provider with a rundown of all the
                        fundamental documentation required for the arrangement of the
                        Services.
                    </p>
                    <p>
                        <span className="font-bold text-blue-600">
                            Relevant Duty Payment:
                        </span>{" "}
                        To advise Sureship and the Service Provider on the gathering paying
                        the enforceable obligation, viz., either the Consignee or the
                        Shipper. In the occasion, assuming either, the Shipper is the
                        gathering paying the errand, or the Consignee declines to pay the
                        assessment as informed at or post the booking regarding the
                        Shipment, Sureship should charge the Customer of such extra accuses
                        along of a headway expense (i.e., a level of the obligation sum) and
                        the Customer consents to pay Sureship, such duty inside (7) working
                        days from the date of raising such bills.
                    </p>
                    <p>
                        Odd Dimension or Heavy Weight Payment: To imply Sureship on
                        Shipments with either peculiar measurement or heavy weight for
                        uncommon directions on bundling and extra charges apply. Such
                        Shipments might be picked and conveyed just on due installment of
                        such reserving.
                    </p>
                    <p>
                        All the Services available on the website are governed by the rules
                        of service and regulations of the respective Service Provider. You
                        are requested to refer to, acquaint and abide by those standards of
                        service and practices of the particular Service Provider, before
                        booking any shipping with us.
                    </p>
                </section>

                {/* User Responsibility */}
                <section className="mb-10">
                    <h2 className="flex items-center text-2xl font-semibold text-blue-950 mb-3">
                        COD liability in
                        snatching cases
                    </h2>
                    <p className=" text-gray-700">
                        In case of forcible snatching or non-payment of COD by buyer,
                        Sureship will not be responsible for COD remittance. Also, the
                        seller must resolve buyer disputes within 24 hrs, failure of which
                        will lead to a hold on the COD remittance. Sureship shall not be
                        liable (in any manner) to remit the Cash-on-Delivery (COD) amount
                        that is to be received as payment by the User, in cases of forcible
                        snatching of the shipments/goods/delivery package.
                    </p>
                </section>

                {/* Data & Website Use */}
                <section className="mb-10">
                    <h2 className="flex items-center text-2xl font-semibold text-blue-950 mb-3">

                        Early COD Plan
                    </h2>
                    <ul className="list-disc ml-6 space-y-2 text-gray-700">
                        <li>KYC must be completed on your Sureship account.</li>
                        <li>
                            For onboarded sellers, the Early COD plan will be activated only
                            if the wallet balance is positive.
                        </li>
                        <li>
                            Early COD plan will be activated on all newly placed orders in the
                            system post plan activation.
                        </li>
                        <li>
                            Once you deactivate your Early COD plan, no early COD charges will
                            be applicable for new orders.
                        </li>
                        <li>
                            In case of negative balance, make sure to recharge your account to
                            receive COD on the due date.
                        </li>
                        <li>
                            In case of any breach in the provided conditions, your early COD
                            charges will remain the same for delayed remittance.
                        </li>
                        <li>
                            You will get a notification over email if you deactivate your plan
                            or breach any of the above-stated conditions.
                        </li>
                    </ul>
                </section>

                {/* Shipment Policy */}
                <section className="mb-10">
                    <h2 className="flex items-center text-2xl font-semibold text-blue-950 mb-3">

                        Use of generic packing Material,
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                        In case the shipment is packed using generic tapes & flyer
                        (Brown/Plain), the courier partners shall not take any liability for
                        pilferage. Sureship will not be responsible for any kind of claim
                        settlement for such shipments.
                    </p>
                </section>

                <section className="mb-10">
                    <h2 className="flex items-center text-2xl font-semibold text-blue-950 mb-3">

                        Shipped Restricted / Dangerous Good – Air & Surface Mode
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                        In case where the merchant ships restricted products by Air/Surface
                        mode, the entire penalty will be borne solely by the merchant.
                    </p>
                </section>

                <section className="mb-10">
                    <h2 className="flex items-center text-2xl font-semibold text-blue-950 mb-3">

                        Shipment Damaged
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                        Courier partners shall entertain claims related to damage only if
                        negative remarks are mentioned on the POD copy. However, if the POD
                        copy is clean, courier partners shall not accept any claim.
                        Similarly, Sureship will not be entitled to any claims of the above
                        manner.
                    </p>
                </section>

                <section className="mb-10">
                    <h2 className="flex items-center text-2xl font-semibold text-blue-950 mb-3">

                        Disputes Related to Damaged / Lost / Leakage / Fake Delivery / Non
                        receipt of Shipment
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                        All the disputes related to Damage, Pilferage, Leakage, Non receipt
                        of shipment, Fake delivery etc. must be raised to Sureship within 24
                        hrs of delivery/delivery attempt. Any such cases raised after 24 hrs
                        will not be entertained by Sureship, Lost Shipment value as per
                        agreement will be credited to wallet.
                    </p>
                </section>

                <section className="mb-10">
                    <h2 className="flex items-center text-2xl font-semibold text-blue-950 mb-3">
                        Product Description & Customer Details
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                        The merchant must ensure that the correct product description is
                        mentioned for the respective products, sold by them. In case of
                        incorrect/incomplete product description shipments may get returned
                        from origin. In such cases the shipping charges will be applicable
                        on return orders and will be irreversible. Also, if any penalty is
                        imposed by the government authorities during the transit of
                        shipments, the merchant will be liable to pay the same.
                    </p>
                </section>

                <section className="mb-10">
                    <h2 className="flex items-center text-2xl font-semibold text-blue-950 mb-3">

                        Cod Remitted Due to Wrong delivery status
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                        In case the COD amount is already remitted to the user, is
                        identified as incorrect due to wrong delivery status updated by the
                        courier partner, the same amount shall be deducted from their wallet
                        amount or from future COD payments.
                    </p>
                </section>

                <section className="mb-10">
                    <h2 className="flex items-center text-2xl font-semibold text-blue-950 mb-3">

                        Penalty for disputed shipments/cases
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                        Sureship, in its sole discretion, shall have the right to levy
                        penalty on the Merchant in relation to shipments /cases which have
                        been disputed by the courier company, Merchant’s customer or by any
                        third party (including any governmental authority/department).The
                        said penalty amount shall be decided by Sureship in its sole
                        discretion and may vary from case to case.
                    </p>
                </section>

                <section className="mb-10">
                    <h2 className="flex items-center text-2xl font-semibold text-blue-950 mb-3">

                        Order cancellation
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                        You can cancel your order from the Sureship panel if the order is in
                        any of the below statuses: AWB Assignment Pickup Scheduled - Pickup
                        Error, We regret to inform you that an order cannot be cancelled if
                        it's in the "out for pickup" status. To Know More on this Please
                        contact Sureship Customer Service
                    </p>
                </section>

                <section className="mb-10">
                    <h2 className="flex items-center text-2xl font-semibold text-blue-950 mb-3">

                        Insurance provision
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                        The merchant must ensure that the correct product description is
                        mentioned for the respective products, sold by them. In case of
                        incorrect/incomplete product description shipments may get returned
                        from origin. In such cases the shipping charges will be applicable
                        on return orders and will be irreversible. Also, if any penalty is
                        imposed by the government authorities during the transit of
                        shipments, the merchant will be liable to pay the same.Under carrier
                        risk- Bigship will be only liable to remit the amount which has been
                        remitted by the carrier to Bigship. Under claim policy of Delhivery
                        LTL-as amount of Rs.10,000 is to be deducted as the processing fee.
                        After the deduction - the salvage value of the shipment (as per the
                        carrier) will be only remitted to the clients wallet in case of
                        insurance under carrier risk option.
                    </p>

                    <p className="text-gray-700 leading-relaxed mb-4">
                        <span className="text-bold text-blue-700">
                            {" "}
                            3rd Party Insurance
                        </span>
                        Under 3rd party insurance - the salvage value of the shipment will
                        be remitted as per the decision by Bigship Management and the
                        carrier.
                    </p>
                </section>

                {/* Prohibited Items */}
                <section className="mb-10">
                    <h2 className="flex items-center text-2xl font-semibold text-blue-950 mb-3">
                      Prohibited
                        Items
                    </h2>
                    <p className="text-gray-700 mb-3">
                        The following items are strictly prohibited from shipping via
                        Sureship:
                    </p>
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 text-gray-700 text-sm">
                        {[
                            "Magnetized Materials",
                            "Infectious Substances",
                            "Bleach",
                            "Flammable Adhesives",
                            "Live Plants",
                            "Dry Ice (Carbon Dioxide, Solid)",
                            "Arms and Ammunitions",
                            "Automobile Batteries",
                            "Lithium Batteries",
                            "Toxic Compounds (Liquid or Gas)",
                            "Fuel for Camp Stoves, Lanterns, Torches or Heating Elements",
                            "Machinery Containing or That Has Contained Fuel",
                            "Insecticides",
                            "Garden Chemicals (Fertilizers, Poisons)",
                            "Oil-Based Paint",
                            "Thinners (Flammable Liquids)",
                            "Firearms, Explosives and Military Equipment",
                            "Uncrossed (Bearer) Drafts / Cheques",
                            "Currency and Coins",
                            "Precious Stones, Gems and Jewelry",
                            "Dangerous Goods",
                            "Pressurized Containers",
                            "Alcohol and Narcotic Substances",
                            "Poison",
                            "Hazardous and Radioactive Materials",
                            "Foodstuff and Liquor",
                            "Pornographic Material",
                        ].map((item, idx) => (
                            <span key={idx} className="bg-gray-100 p-2 rounded-md">
                                • {item}
                            </span>
                        ))}
                    </div>
                </section>

             

                {/* Footer */}
                <footer className="border-t border-gray-200 pt-6 text-center text-gray-600 text-sm">
                    <p>
                        &copy; {new Date().getFullYear()} Sureship Logistics Pvt. Ltd. | All
                        Rights Reserved.
                    </p>
                    <p className="mt-1">
                        For questions, please contact{" "}
                        <a
                            href="mailto:support@sureship.in"
                            className="text-blue-600 underline hover:text-blue-800"
                        >
                           support@sureship.in
                        </a>
                    </p>
                </footer>
            </div>
        </main>
    );
}
